'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { ArrowRight } from 'lucide-react';
import { useServicePurchaseStep } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import { ServicePurchaseStep } from '@/modules/service-purchase/types';
function ConfigureStepContinueButton() {
  const $ = _c(5);
  const {
    goToStep
  } = useServicePurchaseStep();
  let t0;
  if ($[0] !== goToStep) {
    t0 = function handleContinue() {
      goToStep(ServicePurchaseStep.Summary);
    };
    $[0] = goToStep;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleContinue = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowRight className="size-4 transition-transform duration-200 ease-in-out group-hover/link:translate-x-1.5" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handleContinue) {
    t2 = <div className="flex w-full justify-end"><Button variant="default" onClick={handleContinue} className="group/link py-6! pr-14! pl-16!">Continue{t1}</Button></div>;
    $[3] = handleContinue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { ConfigureStepContinueButton };